export default __webpack_public_path__ + "static/media/The Role of the Wolf.1e66ff8f.png";